import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useToasts } from 'react-toast-notifications';
import dayjs from '../Common/dayjs';
import 'react-calendar/dist/Calendar.css';
import Reactdatepicker from 'react-datepicker';

const ClosedDate = (props) => {
    const [closedateList, setClosedateList] = useState([]);
    const [newCloseDate, setNewCloseDate] = useState(null);
    const [changeCloseDateFlg, setChangeCloseDateFlg] = useState(false);
    const [displayedMonth, setDisplayedMonth] = useState(dayjs().format('YYYYMM'));
    const { addToast } = useToasts();
    const jwt = localStorage.getItem('jwt');

    const refreshClosedateList = useCallback(async () => {
        try {
            const params = {
                site_id: props.match.params.siteId
            };
            const closePromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/calendar/holiday/search/`, params, {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                }
            });
            const closedatelist = (await closePromise).data;
            setClosedateList(closedatelist);
            let month = '';
            if (displayedMonth === null) {
                if (closedatelist.length > 0) {
                    month = closedatelist[0].holiday_date.substring(0, 7).replace(/-/g, '');
                } else {
                    month = dayjs().format('YYYYMM');
                }
                setDisplayedMonth(month);
            } else {
                month = displayedMonth;
            }

            const formatDate = (dateString) => dateString.replace(/-/g, '');
            setNewCloseDate(closedatelist.filter(x => {
                if (!x.holiday_date) return false;
                const closedDate = formatDate(x.holiday_date);
                return closedDate >= `${month}01` && closedDate <= `${month}31`;
            }));
            setChangeCloseDateFlg(false);
        } catch (error) {
            console.error('Error fetching closed dates:', error.response ? error.response.data : error.message);
        }
    }, [jwt, props.match.params.siteId, displayedMonth]);

    const inMonth = (dateStr, ym) =>
        (dateStr || '').replace(/-/g, '').startsWith(ym);

    const saveClosedDate = async () => {
        try {
            const monthList = (newCloseDate || []).filter(x => inMonth(x.holiday_date, displayedMonth));
            const params = {
                site_id: props.match.params.siteId,
                selectmonth: displayedMonth,
                closeddatelist: monthList,
            };
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/calendar/holiday/update/`,
                params,
                { headers: { Authorization: `Bearer ${jwt}` } }
            );
            if (response.status === 200) {
                addToast('運休日を更新しました。', { appearance: 'success', autoDismiss: true });
                await refreshClosedateList();
            } else {
                addToast('運休日の更新に失敗しました。', { appearance: 'error', autoDismiss: true });
            }
        } catch (error) {
            console.error('Error updating closed dates:', error);
            addToast('運休日の更新に失敗しました。', { appearance: 'error', autoDismiss: true });
        }
    };
    useEffect(() => {
        setDisplayedMonth(dayjs().format('YYYYMM'));
    }, []);

    useEffect(() => {
        refreshClosedateList();
    }, [refreshClosedateList]);

    const changeMonth = async (date) => {
        if (changeCloseDateFlg) {
            const willSave = window.confirm("変更された内容が保存されていません。保存しますか？\nキャンセルを選択すると、変更内容は破棄されます。");
            if (willSave) {
                await saveClosedDate();
            } else {
                const curYM = displayedMonth;
                const dbCurMonth = (closedateList || []).filter(x => inMonth(x.holiday_date, curYM));
                const others = (newCloseDate || []).filter(x => !inMonth(x.holiday_date, curYM));
                setNewCloseDate([...others, ...dbCurMonth]);
                setChangeCloseDateFlg(false);
            }
        }
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        setDisplayedMonth(`${year}${month}`);
    };

    const changeClosedDate = async (date) => {
        if (!date) return;
        const holiday_date = dayjs(date).format('YYYY-MM-DD');
        const list = Array.isArray(newCloseDate) ? [...newCloseDate] : [];
        const idx = list.findIndex(x => x.holiday_date === holiday_date);
        if (idx >= 0) {
            list.splice(idx, 1);
        } else {
            list.push({ site_id: props.match.params.siteId, holiday_date, upd_date: null });
        }
        setNewCloseDate(list);
        setChangeCloseDateFlg(true);
    };

    const getDayClassName = (date) => {
        const formattedDate = dayjs(date).format('YYYY-MM-DD');
        const isSelected = (newCloseDate || []).some(item => item.holiday_date === formattedDate);
        const isHoliday = (closedateList || []).some(item => item.holiday_date === formattedDate);
        const Holiday = (isHoliday && (isSelected));
        if (isSelected || Holiday) {
            return 'bg-danger text-white';
        }
        return '';
    };

    return (
        <div className="container">
            <div className='row mt-3'>
                <div className='col-auto'>
                    <div className='w-100'>運休日</div>
                    <div className='datepicker-zoom pb-5'>
                        <Reactdatepicker locale="ja"
                            selectedDates={newCloseDate ? newCloseDate.map(x => dayjs(x.holiday_date).toDate()) : []}
                            selectsMultiple
                            onMonthChange={changeMonth}
                            onChange={changeClosedDate}
                            shouldCloseOnSelect={false}
                            filterDate={date => date >= dayjs(`${displayedMonth}01`, 'YYYYMMDD').toDate() && date <= dayjs(`${displayedMonth}01`, 'YYYYMMDD').endOf("month").toDate()}
                            className="form-control"
                            dateFormat="yyyy/MM/dd"
                            placeholderText="運休日を選択してください"
                            inline
                            disabledKeyboardNavigation
                            minDate={dayjs().startOf('month').toDate()}
                            dayClassName={getDayClassName}
                        />
                        <div className='text-center'>
                            <button className='btn btn-primary px-4' disabled={!changeCloseDateFlg} onClick={saveClosedDate}>更新</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ClosedDate;